import styled from 'styled-components';
import { rem } from 'polished';
import { ModalSessionChangeStyled } from '../ModalSessionChangeStyled';

export const ModalSessionChangeStyledDS = styled(ModalSessionChangeStyled)`
    .description {
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }
`;
